import { Link } from 'react-router-dom';

const Header = () => {
	return (
		<header className="bg-gray-50 border-b border-black py-6">
			<div className="max-w-6xl mx-auto flex justify-between items-center px-6">
				{/* Logo / Title */}
				<h1 className="text-2xl font-semibold text-gray-900 tracking-tight">
					<Link to="/" className="hover:text-gray-600 transition-colors duration-200">
						Bark Gallery
					</Link>
				</h1>

				{/* Navigation Menu */}
				<nav>
					<ul className="flex gap-8 text-base">
						<li>
							<Link
								to="/albums"
								className="text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium"
							>
								Albums
							</Link>
						</li>
						<li>
							<Link
								to="/about"
								className="text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium"
							>
								About
							</Link>
						</li>
					</ul>
				</nav>
			</div>
		</header>
	);
};

export default Header;
